import { render, staticRenderFns } from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=template&id=2cfabdf6&scoped=true"
import script from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=script&lang=js"
export * from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=script&lang=js"
import style0 from "./TheIndicatorDatasoureComparisonChart.vue?vue&type=style&index=0&id=2cfabdf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfabdf6",
  null
  
)

export default component.exports